<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div slot="header">
            <i class="fa fa-book"></i> Estados Financieros Vista por Meses
            <i @click="visible = !visible" style="cursor: pointer;" :class="{ 'fa fa-angle-up pull-right': visible, 'fa fa-angle-down pull-right': !visible }"> </i>            
          </div>
          <b-collapse v-model="visible">
          <b-row class="cuerpo">
            <b-col cols="11" col md="2">
              <label for="desde"> Desde:&nbsp; </label><br/>
              <date-picker
                id="fecha"
                v-model="fechaSelect"
                type="month"
                format="MM/YYYY"
                :lang="lang"
                :editable="false"
                style="width: 85%"
                :disabled="loading"
              >
              </date-picker>
            </b-col>
            <b-col cols="11" col md="2">
              <label for="desde"> Hasta:&nbsp; </label><br/>
              <date-picker
                id="fecha"
                v-model="fechaSelectHasta"
                type="month"
                format="MM/YYYY"
                :lang="lang"
                :editable="false"
                style="width: 85%"
                :disabled="loading"
              >
              </date-picker>
            </b-col>
         

            <b-col cols="12" col md="4">
              <b-form-group label="Reporte:">
                <b-input-group>
                  <b-form-select
                    v-model="tipo_reporte"
                    :options="tipos"
                    value-field="id"
                    text-field="nombre"
                    class="mb-3"
                    style="min-width: 80px"
                    @change="limpiar"
                  >
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="6" col md="3" ml-md="4" v-show="tipo_reporte"><br/>
              <button
                v-b-tooltip.hover
                class="btn btn-sm btn-success text-white"
                @click="cargarDatos('n')"
                style="margin-top: 0.4em; margin-right: 1em"
                title="Cargar datos"
              >
                <i class="fa fa-search"></i>
              </button>

              <button
                v-b-tooltip.hover
                class="btn btn-sm btn-success text-white"
                @click="cargarDatos('s')"
                style="margin-top: 0.4em; margin-right: 1em"
                title="Exportar a Excel"
              >
                <i class="fa fa-file-excel-o"></i>
              </button>
            </b-col>
          </b-row>
          </b-collapse>

          <section v-show="loading">
            <loader-ag/>
            <b-row>
              <p class="cuerpo text-primary mx-auto">Por favor espere...</p>
            </b-row>
          </section>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="table-responsive">
      <b-card v-if="!loading && registros.length>0">
      <div class="cuerpo">
        <b-table  responsive  sticky-header="500px" hover :items="registros" :fields="columnas"></b-table>
      </div>
      </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import toastr from "toastr";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";
import LoaderAg from "../../components/LoaderAg";
import Vue2Filters from "vue2-filters";
import { addCommas } from "../../shared/utils";

export default {
  name: "pdf-comprobante",
  mixins: [Vue2Filters.mixin],
  components: {
    DatePicker,
    LoaderAg
  },
  data() {
    return {
      fechaSelect: undefined,
      fechaSelectHasta: undefined,
      desde: undefined,
      hasta: undefined,
      tipo: undefined,
      loading: false,
      tipo_reporte: undefined,
      tipos: [],
      lang: {formatLocale: {firstDayOfWeek: 1}},
      registros:[],
      columnas: [],
      nombre_excel:'',
      visible:true
        
  
    };
  },
  created() {
    this.getTiposEF();
  },
  methods: {
    limpiar(){
      this.registros = [];
      this.fields= [];
      this.columnas = [];
    },
   async getTiposEF() {
      let model={};
      model.empresa_id = this.empresaId;
      this.tipos=[];
      // eslint-disable-next-line no-undef
      let req = await axios.post("/api/catalogos/reportes",{model});
      if(req.data){
        let datos = req.data;
        this.tipos = datos.data;
      }
      this.tipo_reporte=undefined;
},
    async cargarDatos(excel = 'n'){
      this.loading = true;
      this.registros=[];
      this.columnas = [];
      if (!this.desde || !this.hasta)
        return toastr["warning"]("Favor seleccione fechas");
      let nombre_excel = 'Estados_Situacion_Financiera';
      if (this.tipo_reporte == 2 || this.tipo_reporte == 4 ||this.tipo_reporte == 6){
        nombre_excel = 'Estados_de_Resultado';

      }
      let filtros = {
        desde: this.desde,
        hasta: this.hasta,
        empresa_id: this.empresaId,
        tipo: this.tipo_reporte,
        excel
      };
      if (excel == "s") {
          toastr["info"](
            "Generando Excel. Favor Espere"
          );
          try {
            // eslint-disable-next-line no-undef
            const response = await axios.post("/api/reportes/ef-mensuales", filtros,
              {
                responseType: 'blob',
              }
            );
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            this.loading = false;
            link.setAttribute('download', `${nombre_excel}-${this.empresaId}.xlsx`);
            document.body.appendChild(link);
            link.click();
          } catch(error){
            console.log(error);
          }

        } else {
          try {
            toastr["info"]("Generando por favor espere...");
            // eslint-disable-next-line no-undef
            const {status, data} = await axios.post("/api/reportes/ef-mensuales", filtros);
            
            if(!status ==200  || !data || !data.datos.length>0) return this.loading=false;
              
              this.registros = data.datos;
              if(data && data.datos.length > 0){
                const keys = Object.keys(data.datos[0]);
                for (let columna of keys) {
                    let field = {key: columna, stickyColumn: columna == 'concepto' ? true : false};
                    if(columna !== 'concepto'){
                      field.class = 'text-right';
                      field.formatter = (value)=>addCommas(value);
                    }
                    this.columnas.push(field);
                    this.loading = false;
                }
              }

            
          }catch (e) {
            this.loading = false;
            console.error(e);
          }
        }
    },
    cargar() {
      this.loading = true;
      setTimeout(() => {
        this.cargarPdf();
      }, 300);
    },
    async cargarPdf() {
      this.anio = undefined;
      this.mes = undefined;
      //this.centro_id = this.centro_id ? this.centro_id : 0;
      if (!this.filtro_mes_anio)
        return toastr["warning"]("Favor seleccione un mes válido");
      let datos = this.filtro_mes_anio.split("-");
      this.anio = datos[0];
      this.mes = datos[1];

      if (!isNaN(this.anio) && !isNaN(this.mes)) {
        toastr["info"]("Generando por favor espere...");
        
        let resolvedRoute = this.$router.resolve({
          name: 'pdf-estados-financieros',
          params: {url: 'estados_financieros', empresa: this.empresaId, anio: this.anio, mes: this.mes, tipo: this.tipo_reporte, aprobados:this.aprobados}
        });
        console.log(resolvedRoute);
        window.open(resolvedRoute.href, '_blank');
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters("authentication", ["empresaId"])
  },
  watch: {
    fechaSelect: _.debounce(function (date) {
      this.desde = moment(date).format("YYYY-MM-DD");
    }, 300),
    fechaSelectHasta: _.debounce(function (date_hasta) {
      this.hasta = moment(date_hasta).format("YYYY-MM-DD");
    }, 300),

  }
};
</script>
<style lang="css" scoped>
.card-body{
  padding:0;
}
.cuerpo{
  padding:1.25rem;
}
</style>
